import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  CouponsDiscountValueScalar: any;
  CouponsDurationValueScalar: any;
  /** A date-time string at UTC, such as 2019-12-03T09:54:33Z, compliant with the date-time format. */
  DateTime: any;
  /** The `Upload` scalar type represents a file upload. */
  Upload: any;
};


export type AmlInput = {
  annualIncome: Scalars['String'];
  investorDeclares?: Maybe<InvestorDeclares>;
  investorPoliticalDeclaration: PoliticalDeclarationInput;
  investorRepresentativeDeclares?: Maybe<InvestorDeclares>;
  investorRepresentativePoliticalDeclaration?: Maybe<PoliticalDeclarationInput>;
  originOfProperty?: Maybe<OriginOfProperty>;
  purposeOfIncome: PurposeOfIncome;
  sourceOfIncome: SourceOfIncome;
  sourceOfIncomeDeal: SourceOfIncomeDeal;
};

export type AmlModel = {
  __typename?: 'AMLModel';
  annualIncome: Scalars['String'];
  investorDeclares?: Maybe<InvestorDeclaresModel>;
  investorPoliticalDeclaration?: Maybe<PoliticalDeclaration>;
  investorRepresentativeDeclares?: Maybe<InvestorDeclaresModel>;
  investorRepresentativePoliticalDeclaration?: Maybe<PoliticalDeclaration>;
  originOfProperty?: Maybe<OriginOfPropertyModel>;
  purposeOfIncome: PurposeOfIncomeModel;
  sourceOfIncome: SourceOfIncomeModel;
  sourceOfIncomeDeal: SourceOfIncomeDealModel;
  swornStatement?: Maybe<Scalars['String']>;
};

export type AmlUpdateInput = {
  annualIncome?: Maybe<Scalars['String']>;
  investorDeclares?: Maybe<InvestorDeclaresUpdate>;
  investorPoliticalDeclaration?: Maybe<PoliticalDeclarationInputUpdate>;
  investorRepresentativeDeclares?: Maybe<InvestorDeclaresUpdate>;
  investorRepresentativePoliticalDeclaration?: Maybe<PoliticalDeclarationInputUpdate>;
  originOfProperty?: Maybe<OriginOfProperty>;
  purposeOfIncome?: Maybe<PurposeOfIncomeUpdate>;
  sourceOfIncome?: Maybe<SourceOfIncomeUpdate>;
  sourceOfIncomeDeal?: Maybe<SourceOfIncomeDealUpdate>;
};

export type AresCompanyModel = {
  __typename?: 'AresCompanyModel';
  city: Scalars['String'];
  code: Scalars['String'];
  country: Scalars['String'];
  dic?: Maybe<Scalars['String']>;
  ico: Scalars['String'];
  name: Scalars['String'];
  street: Scalars['String'];
};

export enum Contract_Label {
  Authorized = 'AUTHORIZED',
  Canceled = 'CANCELED',
  Test = 'TEST',
  Uncategorized = 'UNCATEGORIZED'
}

export enum Contract_Source_Type {
  Partner = 'PARTNER',
  Web = 'WEB'
}

export type CircumstanceInput = {
  absenceOfFaceToFaceIdentification: Scalars['Boolean'];
  cantProvideBusinessScopeInformation: Scalars['Boolean'];
  exposedPersonRelationship: Scalars['Boolean'];
  fictitiousDocuments: Scalars['Boolean'];
  fundamentalistPersonRelationship: Scalars['Boolean'];
  lowIncomeShareHolder: Scalars['Boolean'];
  nervousBehavior: Scalars['Boolean'];
  nonStandardReward: Scalars['Boolean'];
  notActingHimself: Scalars['Boolean'];
  propertyConviction: Scalars['Boolean'];
  propertyProsecution: Scalars['Boolean'];
  recordKeepingInterest: Scalars['Boolean'];
  refusalOfCooperation: Scalars['Boolean'];
  refusalOfIdentification: Scalars['Boolean'];
  refusalToProveWarrant: Scalars['Boolean'];
  remoteMeeting: Scalars['Boolean'];
  selectsRemoteConsultant: Scalars['Boolean'];
  shareHolderConsultantRelation: Scalars['Boolean'];
  shareHolderIsInHurry: Scalars['Boolean'];
  spareDocument: Scalars['Boolean'];
  specification?: Maybe<Scalars['String']>;
  suspiciousDeal: Scalars['Boolean'];
  thirdPersonAttendance: Scalars['Boolean'];
  veracityOfData: Scalars['Boolean'];
  withdrawalContractInterest: Scalars['Boolean'];
};

export type ConsultantCompanyModelBase = {
  __typename?: 'ConsultantCompanyModelBase';
  isAvailableSporoRegular: Scalars['Boolean'];
  name: Scalars['String'];
  private: Scalars['Boolean'];
  tesla: Scalars['Boolean'];
  uuid: Scalars['String'];
};

export type ConsultantInput = {
  businessName?: Maybe<Scalars['String']>;
  company: Scalars['String'];
  email: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  lastName: Scalars['String'];
  name: Scalars['String'];
  phone: Scalars['String'];
  place: Scalars['String'];
};

export type ConsultantModel = {
  __typename?: 'ConsultantModel';
  businessName?: Maybe<Scalars['String']>;
  company: ConsultantCompanyModelBase;
  efolioOzId?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  lastName: Scalars['String'];
  name: Scalars['String'];
  phone: Scalars['String'];
  place: Scalars['String'];
  uuid: Scalars['String'];
};

export type ConsultantUpdateInput = {
  businessName?: Maybe<Scalars['String']>;
  company?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  place?: Maybe<Scalars['String']>;
};

export type ContactInput = {
  bankAccount?: Maybe<Scalars['String']>;
  bankAccountConfirmation?: Maybe<Scalars['Boolean']>;
  bankCode?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  phone: Scalars['String'];
};

export type ContactModel = {
  __typename?: 'ContactModel';
  bankAccount?: Maybe<Scalars['String']>;
  bankAccountConfirmation?: Maybe<Scalars['Boolean']>;
  bankCode?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  phone: Scalars['String'];
};

export type ContactUpdateInput = {
  bankAccount?: Maybe<Scalars['String']>;
  bankAccountConfirmation?: Maybe<Scalars['Boolean']>;
  bankCode?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
};

export type ContractCircumstanceModel = {
  __typename?: 'ContractCircumstanceModel';
  absenceOfFaceToFaceIdentification: Scalars['Boolean'];
  cantProvideBusinessScopeInformation: Scalars['Boolean'];
  date: Scalars['DateTime'];
  exposedPersonRelationship: Scalars['Boolean'];
  fictitiousDocuments: Scalars['Boolean'];
  fundamentalistPersonRelationship: Scalars['Boolean'];
  lowIncomeShareHolder: Scalars['Boolean'];
  nervousBehavior: Scalars['Boolean'];
  nonStandardReward: Scalars['Boolean'];
  notActingHimself: Scalars['Boolean'];
  propertyConviction: Scalars['Boolean'];
  propertyProsecution: Scalars['Boolean'];
  recordKeepingInterest: Scalars['Boolean'];
  refusalOfCooperation: Scalars['Boolean'];
  refusalOfIdentification: Scalars['Boolean'];
  refusalToProveWarrant: Scalars['Boolean'];
  remoteMeeting: Scalars['Boolean'];
  selectsRemoteConsultant: Scalars['Boolean'];
  shareHolderConsultantRelation: Scalars['Boolean'];
  shareHolderIsInHurry: Scalars['Boolean'];
  spareDocument: Scalars['Boolean'];
  specification?: Maybe<Scalars['String']>;
  suspiciousDeal: Scalars['Boolean'];
  thirdPersonAttendance: Scalars['Boolean'];
  uuid: Scalars['String'];
  veracityOfData: Scalars['Boolean'];
  withdrawalContractInterest: Scalars['Boolean'];
};

export type ContractCommunicationInput = {
  email: Scalars['Boolean'];
  information: Scalars['Boolean'];
  remoteControl: Scalars['Boolean'];
};

export type ContractConsultantCompanyModel = {
  __typename?: 'ContractConsultantCompanyModel';
  commissionPosition?: Maybe<Scalars['String']>;
  company?: Maybe<ConsultantCompanyModelBase>;
  distributionAgreementDate?: Maybe<Scalars['DateTime']>;
  efolioOZAddressUuid?: Maybe<Scalars['String']>;
  efolioOZId: Scalars['String'];
  email?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  identificationNumber?: Maybe<Scalars['String']>;
  isCompany: Scalars['Boolean'];
  lastName?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  representationAgreementDate?: Maybe<Scalars['DateTime']>;
  validityFrom?: Maybe<Scalars['DateTime']>;
  validityTo?: Maybe<Scalars['DateTime']>;
};

export type ContractConsultantModel = {
  __typename?: 'ContractConsultantModel';
  circumstance?: Maybe<ContractCircumstanceModel>;
  consultant: ConsultantModel;
  consultantSmsCode?: Maybe<Scalars['String']>;
  consultantSmsSent?: Maybe<Scalars['DateTime']>;
  consultantSmsVerified?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  products?: Maybe<Array<ContractProductModel>>;
};

export type ContractCouponsInput = {
  discount: Scalars['Boolean'];
  duration?: Maybe<Scalars['CouponsDurationValueScalar']>;
  value?: Maybe<Scalars['CouponsDiscountValueScalar']>;
};

export type ContractCouponsInputV2 = {
  discount: Scalars['Boolean'];
  duration?: Maybe<Scalars['CouponsDurationValueScalar']>;
  productId: Scalars['String'];
  uuid?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['CouponsDiscountValueScalar']>;
};

export type ContractCouponsModel = {
  __typename?: 'ContractCouponsModel';
  discount: Scalars['Boolean'];
  duration?: Maybe<Scalars['String']>;
  uuid: Scalars['String'];
  value?: Maybe<Scalars['String']>;
};

export type ContractInput = {
  aml?: Maybe<AmlInput>;
  communication?: Maybe<ContractCommunicationInput>;
  consultant?: Maybe<ConsultantInput>;
  customer: CustomerInput;
  distributorTargetMarket?: Maybe<Target_Market_Result>;
  investmentEstimatedAmount?: Maybe<Scalars['Int']>;
  investmentType?: Maybe<Scalars['String']>;
  isDraft: Scalars['Boolean'];
  isTesla?: Maybe<Scalars['Boolean']>;
  monthlyInvestmentAmount?: Maybe<Scalars['Int']>;
  paymentMethodEntryFee?: Maybe<Payment_Method_Entry_Fee>;
  private: Scalars['Boolean'];
  products?: Maybe<Array<ContractProductInput>>;
  questionnaire?: Maybe<ContractQuestionnaireInput>;
  questionnaireV2?: Maybe<ContractQuestionnaireV2Input>;
  referral?: Maybe<Scalars['String']>;
  targetInvestmentAmount?: Maybe<Scalars['Int']>;
  targetMarket?: Maybe<TargetMarketInput>;
  termsAndConditions?: Maybe<Scalars['Boolean']>;
};

export type ContractInvestmentTypeModel = {
  __typename?: 'ContractInvestmentTypeModel';
  code: Scalars['String'];
  name: Scalars['String'];
  uuid: Scalars['String'];
};

export type ContractModel = {
  __typename?: 'ContractModel';
  aml?: Maybe<AmlModel>;
  circumstance?: Maybe<ContractCircumstanceModel>;
  code: Scalars['String'];
  communication?: Maybe<DealCommunication>;
  consultant?: Maybe<ConsultantModel>;
  consultantSmsSent?: Maybe<Scalars['DateTime']>;
  consultantSmsVerified?: Maybe<Scalars['DateTime']>;
  coupons?: Maybe<ContractCouponsModel>;
  createdAt: Scalars['String'];
  createdBy?: Maybe<Scalars['String']>;
  createdEmailSent?: Maybe<Scalars['DateTime']>;
  customer: CustomerModel;
  distributorTargetMarket?: Maybe<Target_Market_Result>;
  documents?: Maybe<Array<DocumentFileModel>>;
  generatedDocuments?: Maybe<Array<GeneratedDocumentModel>>;
  id: Scalars['Int'];
  investmentEstimatedAmount?: Maybe<Scalars['Float']>;
  investmentType?: Maybe<ContractInvestmentTypeModel>;
  isDraft: Scalars['Boolean'];
  isOnlyReserved?: Maybe<Scalars['Boolean']>;
  label?: Maybe<Contract_Label>;
  monthlyInvestmentAmount?: Maybe<Scalars['Float']>;
  no?: Maybe<Scalars['String']>;
  paymentMethodEntryFee?: Maybe<Payment_Method_Entry_Fee>;
  paymentVerified: Scalars['Boolean'];
  private: Scalars['Boolean'];
  products?: Maybe<Array<ContractProductModel>>;
  questionnaire?: Maybe<Questionnaire>;
  questionnaireVersion: Scalars['Int'];
  referral?: Maybe<Scalars['String']>;
  smsSent?: Maybe<Scalars['DateTime']>;
  smsVerified: Scalars['Boolean'];
  smsVerifiedDate?: Maybe<Scalars['DateTime']>;
  source?: Maybe<Contract_Source_Type>;
  targetInvestmentAmount?: Maybe<Scalars['Float']>;
  targetMarket?: Maybe<TargetMarketModel>;
  termsAndConditions: Scalars['Boolean'];
  tesla: Scalars['Boolean'];
  validated: Scalars['Boolean'];
  validatedAt?: Maybe<Scalars['DateTime']>;
  validationType?: Maybe<Validation_Type>;
  version?: Maybe<Scalars['Int']>;
};

export type ContractProductInput = {
  investmentEstimatedAmount?: Maybe<Scalars['Int']>;
  investmentType: Scalars['String'];
  monthlyInvestmentAmount?: Maybe<Scalars['Int']>;
  paymentMethodEntryFee?: Maybe<Payment_Method_Entry_Fee>;
  targetInvestmentAmount?: Maybe<Scalars['Int']>;
  uuid?: Maybe<Scalars['String']>;
};

export type ContractProductModel = {
  __typename?: 'ContractProductModel';
  coupon?: Maybe<ContractCouponsModel>;
  investmentEstimatedAmount?: Maybe<Scalars['Float']>;
  investmentType?: Maybe<ContractInvestmentTypeModel>;
  monthlyInvestmentAmount?: Maybe<Scalars['Float']>;
  paymentMethodEntryFee?: Maybe<Payment_Method_Entry_Fee>;
  targetInvestmentAmount?: Maybe<Scalars['Float']>;
  uuid: Scalars['String'];
};

export type ContractQuestionnaireInput = {
  dealAmount?: Maybe<Scalars['String']>;
  dealFrequency?: Maybe<Scalars['String']>;
  dealType?: Maybe<QuestionnaireDealType>;
  experienceLength?: Maybe<Scalars['String']>;
  knowledgeLevel?: Maybe<Scalars['String']>;
  knownInvestmentServices?: Maybe<QuestionnaireKnownInvestmentServices>;
  knownInvestmentTools?: Maybe<QuestionnaireKnownInvestmentTools>;
  refuseFilling: Scalars['Boolean'];
  workingExperience?: Maybe<QuestionnaireWorkingExperience>;
};

export type ContractQuestionnaireV2Input = {
  bondsAre?: Maybe<Scalars['String']>;
  collectiveInvestmentsBenefits?: Maybe<Scalars['String']>;
  collectiveInvestmentsYouGetting?: Maybe<Scalars['String']>;
  dealAmount?: Maybe<Scalars['String']>;
  dealFrequency?: Maybe<Scalars['String']>;
  dealType?: Maybe<QuestionnaireV2DealType>;
  differenceBetweenInvestmentConsultingAndMediatingInvestments?: Maybe<Scalars['String']>;
  experienceLength?: Maybe<Scalars['String']>;
  higherEducation?: Maybe<QuestionnaireV2HigherEductionInput>;
  investmentRelationProfession?: Maybe<Scalars['String']>;
  investmentShareCharacteristics?: Maybe<Scalars['String']>;
  refuseFilling: Scalars['Boolean'];
  relationRiskAndReturn?: Maybe<Scalars['String']>;
  shareCertificateCharacteristics?: Maybe<Scalars['String']>;
};

export type ContractUpdateInput = {
  aml?: Maybe<AmlUpdateInput>;
  communication?: Maybe<ContractCommunicationInput>;
  consultant?: Maybe<ConsultantUpdateInput>;
  customer?: Maybe<CustomerUpdateInput>;
  distributorTargetMarket?: Maybe<Target_Market_Result>;
  investmentEstimatedAmount?: Maybe<Scalars['Int']>;
  investmentType?: Maybe<Scalars['String']>;
  isDraft?: Maybe<Scalars['Boolean']>;
  isTesla?: Maybe<Scalars['Boolean']>;
  monthlyInvestmentAmount?: Maybe<Scalars['Int']>;
  paymentMethodEntryFee?: Maybe<Payment_Method_Entry_Fee>;
  products?: Maybe<Array<ContractProductInput>>;
  questionnaire?: Maybe<ContractQuestionnaireInput>;
  questionnaireV2?: Maybe<ContractQuestionnaireV2Input>;
  referral?: Maybe<Scalars['String']>;
  targetInvestmentAmount?: Maybe<Scalars['Int']>;
  targetMarket?: Maybe<TargetMarketUpdateInput>;
  termsAndConditions?: Maybe<Scalars['Boolean']>;
};



export type CustomerAddressInput = {
  city: Scalars['String'];
  code: Scalars['String'];
  country: Scalars['String'];
  street: Scalars['String'];
};

export type CustomerAddressModel = {
  __typename?: 'CustomerAddressModel';
  city: Scalars['String'];
  code: Scalars['String'];
  country: Scalars['String'];
  street: Scalars['String'];
};

export type CustomerAddressUpdateInput = {
  city?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  street?: Maybe<Scalars['String']>;
};

export type CustomerBaseInput = {
  address: CustomerAddressInput;
  birthCountry: Scalars['String'];
  birthPlace: Scalars['String'];
  businessName?: Maybe<Scalars['String']>;
  document?: Maybe<DocumentInput>;
  id: Scalars['String'];
  lastName: Scalars['String'];
  name: Scalars['String'];
  sex: Sex;
};

export type CustomerBaseModel = {
  __typename?: 'CustomerBaseModel';
  address: CustomerAddressModel;
  birthCountry: Scalars['String'];
  birthPlace: Scalars['String'];
  businessName?: Maybe<Scalars['String']>;
  document?: Maybe<DocumentModel>;
  id: Scalars['String'];
  lastName: Scalars['String'];
  name: Scalars['String'];
  sex: Sex;
};

export type CustomerBaseUpdateInput = {
  address?: Maybe<CustomerAddressUpdateInput>;
  birthCountry?: Maybe<Scalars['String']>;
  birthPlace?: Maybe<Scalars['String']>;
  businessName?: Maybe<Scalars['String']>;
  document?: Maybe<DocumentUpdateInput>;
  id?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  sex?: Maybe<Sex>;
};

export type CustomerInput = {
  acting?: Maybe<CustomerBaseInput>;
  address: CustomerAddressInput;
  birthCountry: Scalars['String'];
  birthPlace: Scalars['String'];
  businessName?: Maybe<Scalars['String']>;
  contact?: Maybe<ContactInput>;
  contactAddress?: Maybe<CustomerAddressInput>;
  dic?: Maybe<Scalars['String']>;
  document?: Maybe<DocumentInput>;
  foreign?: Maybe<ForeignInput>;
  ico?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  lastName: Scalars['String'];
  name: Scalars['String'];
  sex: Sex;
  type: Investor_Type;
};

export type CustomerModel = {
  __typename?: 'CustomerModel';
  acting?: Maybe<CustomerBaseModel>;
  address: CustomerAddressModel;
  birthCountry: Scalars['String'];
  birthPlace: Scalars['String'];
  businessName?: Maybe<Scalars['String']>;
  contact: ContactModel;
  contactAddress?: Maybe<CustomerAddressModel>;
  dic?: Maybe<Scalars['String']>;
  document?: Maybe<DocumentModel>;
  foreign?: Maybe<ForeignModel>;
  ico?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  lastName: Scalars['String'];
  name: Scalars['String'];
  sex: Sex;
  type: Investor_Type;
};

export type CustomerUpdateInput = {
  acting?: Maybe<CustomerBaseUpdateInput>;
  address?: Maybe<CustomerAddressUpdateInput>;
  birthCountry?: Maybe<Scalars['String']>;
  birthPlace?: Maybe<Scalars['String']>;
  businessName?: Maybe<Scalars['String']>;
  contact?: Maybe<ContactUpdateInput>;
  contactAddress?: Maybe<CustomerAddressInput>;
  dic?: Maybe<Scalars['String']>;
  document?: Maybe<DocumentUpdateInput>;
  foreign?: Maybe<ForeignUpdateInput>;
  ico?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  sex?: Maybe<Sex>;
  type?: Maybe<Investor_Type>;
};

export enum Document_Type {
  DriverLicense = 'driver_license',
  Op = 'op',
  Pas = 'pas',
  ResidencePermit = 'residence_permit'
}


export type DealCommunication = {
  __typename?: 'DealCommunication';
  email: Scalars['Boolean'];
  information: Scalars['Boolean'];
  remoteControl: Scalars['Boolean'];
};

export type DocumentFileInput = {
  file: Scalars['Upload'];
  type: Document_Type;
  uuid?: Maybe<Scalars['String']>;
};

export type DocumentFileModel = {
  __typename?: 'DocumentFileModel';
  link?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  path: Scalars['String'];
  type: Document_Type;
  uuid: Scalars['String'];
};

export type DocumentInput = {
  citizen: Scalars['String'];
  issuedBy: Scalars['String'];
  no: Scalars['String'];
  taxResident: Scalars['String'];
  type: Document_Type;
  validity: Scalars['String'];
};

export type DocumentModel = {
  __typename?: 'DocumentModel';
  citizen: Scalars['String'];
  issuedBy: Scalars['String'];
  no: Scalars['String'];
  taxResident: Scalars['String'];
  type: Document_Type;
  uuid: Scalars['String'];
  validity: Scalars['String'];
};

export type DocumentUpdateInput = {
  citizen?: Maybe<Scalars['String']>;
  issuedBy?: Maybe<Scalars['String']>;
  no?: Maybe<Scalars['String']>;
  taxResident?: Maybe<Scalars['String']>;
  type?: Maybe<Document_Type>;
  validity?: Maybe<Scalars['String']>;
};

export type ForeignInput = {
  birthPlace: Scalars['String'];
  id: Scalars['String'];
  taxDomicile: Scalars['String'];
};

export type ForeignModel = {
  __typename?: 'ForeignModel';
  birthPlace: Scalars['String'];
  id: Scalars['String'];
  taxDomicile: Scalars['String'];
};

export type ForeignUpdateInput = {
  birthPlace?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  taxDomicile?: Maybe<Scalars['String']>;
};

export type GeneratedDocumentModel = {
  __typename?: 'GeneratedDocumentModel';
  name: Scalars['String'];
  path: Scalars['String'];
};

export enum Investor_Type {
  Osvc = 'osvc',
  Person = 'person'
}

export type IdentityLoginModel = {
  __typename?: 'IdentityLoginModel';
  token: Scalars['String'];
};

export type IdentityParsedToken = {
  __typename?: 'IdentityParsedToken';
  efolioOzId?: Maybe<Scalars['String']>;
  exp: Scalars['Int'];
  iat: Scalars['Int'];
  phone: Scalars['String'];
  scope: Array<LoginScope>;
};

export type InvestorDeclares = {
  citizenAnotherCountry: Scalars['Boolean'];
  citizenAnotherCountrySpec?: Maybe<Scalars['String']>;
  corporateAnotherCountry: Scalars['Boolean'];
  corporateAnotherCountrySpec?: Maybe<Scalars['String']>;
  residentAnotherCountry: Scalars['Boolean'];
  residentAnotherCountrySpec?: Maybe<Scalars['String']>;
  residentOfCurrentCountry: Scalars['Boolean'];
};

export type InvestorDeclaresModel = {
  __typename?: 'InvestorDeclaresModel';
  citizenAnotherCountry?: Maybe<Scalars['Boolean']>;
  citizenAnotherCountrySpec?: Maybe<Scalars['String']>;
  corporateAnotherCountry?: Maybe<Scalars['Boolean']>;
  corporateAnotherCountrySpec?: Maybe<Scalars['String']>;
  residentAnotherCountry?: Maybe<Scalars['Boolean']>;
  residentAnotherCountrySpec?: Maybe<Scalars['String']>;
  residentOfCurrentCountry?: Maybe<Scalars['Boolean']>;
};

export type InvestorDeclaresUpdate = {
  citizenAnotherCountry?: Maybe<Scalars['Boolean']>;
  citizenAnotherCountrySpec?: Maybe<Scalars['String']>;
  corporateAnotherCountry?: Maybe<Scalars['Boolean']>;
  corporateAnotherCountrySpec?: Maybe<Scalars['String']>;
  residentAnotherCountry?: Maybe<Scalars['Boolean']>;
  residentAnotherCountrySpec?: Maybe<Scalars['String']>;
  residentOfCurrentCountry?: Maybe<Scalars['Boolean']>;
};

export enum LoginScope {
  Private = 'private',
  Tesla = 'tesla'
}

export type Mutation = {
  __typename?: 'Mutation';
  contractConsultantUpdateCircumstance: ContractCircumstanceModel;
  contractConsultantUpdateCoupons: ContractCouponsModel;
  contractConsultantUpdateCouponsV2: Array<ContractCouponsModel>;
  contractConsultantVerifySms: Scalars['Boolean'];
  contractLogin: Scalars['Boolean'];
  contractLoginVerification: IdentityLoginModel;
  createContract: ContractModel;
  createContractProposal: Scalars['String'];
  login: IdentityLoginModel;
  partnerLogin: Scalars['Boolean'];
  partnerLoginVerification: IdentityLoginModel;
  publishContract: ContractModel;
  sendDraftCreationEmail: ContractModel;
  updateContract: ContractModel;
  updateDocuments: Array<DocumentFileModel>;
  verifyContractBySMS: Scalars['Boolean'];
};


export type MutationContractConsultantUpdateCircumstanceArgs = {
  code: Scalars['String'];
  consultantToken: Scalars['String'];
  data: CircumstanceInput;
};


export type MutationContractConsultantUpdateCouponsArgs = {
  code: Scalars['String'];
  consultantToken: Scalars['String'];
  data: ContractCouponsInput;
};


export type MutationContractConsultantUpdateCouponsV2Args = {
  code: Scalars['String'];
  consultantToken: Scalars['String'];
  data: Array<ContractCouponsInputV2>;
};


export type MutationContractConsultantVerifySmsArgs = {
  code: Scalars['String'];
  consultantToken: Scalars['String'];
  smsCode: Scalars['String'];
};


export type MutationContractLoginArgs = {
  code: Scalars['String'];
  pushToken: Scalars['String'];
};


export type MutationContractLoginVerificationArgs = {
  code: Scalars['String'];
};


export type MutationCreateContractArgs = {
  data: ContractInput;
};


export type MutationCreateContractProposalArgs = {
  code: Scalars['String'];
};


export type MutationLoginArgs = {
  password: Scalars['String'];
};


export type MutationPartnerLoginArgs = {
  phone: Scalars['String'];
};


export type MutationPartnerLoginVerificationArgs = {
  code: Scalars['String'];
};


export type MutationPublishContractArgs = {
  code: Scalars['String'];
};


export type MutationSendDraftCreationEmailArgs = {
  code: Scalars['String'];
};


export type MutationUpdateContractArgs = {
  code: Scalars['String'];
  data: ContractUpdateInput;
  id: Scalars['Int'];
};


export type MutationUpdateDocumentsArgs = {
  code: Scalars['String'];
  files: Array<DocumentFileInput>;
  id: Scalars['Int'];
};


export type MutationVerifyContractBySmsArgs = {
  code: Scalars['String'];
  id: Scalars['Int'];
  verificationCode: Scalars['String'];
};

export type OriginOfProperty = {
  specification?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

export type OriginOfPropertyModel = {
  __typename?: 'OriginOfPropertyModel';
  specification?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

export enum Payment_Method_Entry_Fee {
  Express = 'EXPRESS',
  Regular = 'REGULAR'
}

export type PoliticalDeclaration = {
  __typename?: 'PoliticalDeclaration';
  penalty?: Maybe<Scalars['Boolean']>;
  pep?: Maybe<Scalars['Boolean']>;
};

export type PoliticalDeclarationInput = {
  penalty: Scalars['Boolean'];
  pep: Scalars['Boolean'];
};

export type PoliticalDeclarationInputUpdate = {
  penalty?: Maybe<Scalars['Boolean']>;
  pep?: Maybe<Scalars['Boolean']>;
};

export type PurposeOfIncome = {
  specification?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

export type PurposeOfIncomeModel = {
  __typename?: 'PurposeOfIncomeModel';
  specification?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

export type PurposeOfIncomeUpdate = {
  specification?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export enum Questionnaire_Profile_Types {
  Balanced = 'BALANCED',
  Conservative = 'CONSERVATIVE',
  Dynamic = 'DYNAMIC'
}

export type Query = {
  __typename?: 'Query';
  contract: ContractModel;
  contractConsultant: ContractConsultantModel;
  contractConsultantSendSms: Scalars['Boolean'];
  contractConsultantToken: Scalars['String'];
  getCompanies: Array<ConsultantCompanyModelBase>;
  getCompanyByIc: AresCompanyModel;
  getEfolioOZ: ContractConsultantCompanyModel;
  getInvestmentTypes: Array<ContractInvestmentTypeModel>;
  sendValidationSMS: Scalars['Boolean'];
  verify: IdentityParsedToken;
};


export type QueryContractArgs = {
  code: Scalars['String'];
};


export type QueryContractConsultantArgs = {
  code: Scalars['String'];
  consultantToken: Scalars['String'];
};


export type QueryContractConsultantSendSmsArgs = {
  code: Scalars['String'];
  consultantToken: Scalars['String'];
};


export type QueryContractConsultantTokenArgs = {
  code: Scalars['String'];
};


export type QueryGetCompanyByIcArgs = {
  ic: Scalars['String'];
};


export type QueryGetEfolioOzArgs = {
  efolioOzId: Scalars['String'];
};


export type QuerySendValidationSmsArgs = {
  code: Scalars['String'];
  id: Scalars['Int'];
  resend?: Maybe<Scalars['Boolean']>;
};


export type QueryVerifyArgs = {
  token: Scalars['String'];
};

export type QuestionnaireDealType = {
  bonds: Scalars['Boolean'];
  derivatives: Scalars['Boolean'];
  securities: Scalars['Boolean'];
  stocks: Scalars['Boolean'];
};

export type QuestionnaireDealTypeModel = {
  __typename?: 'QuestionnaireDealTypeModel';
  bonds: Scalars['Boolean'];
  derivatives: Scalars['Boolean'];
  securities: Scalars['Boolean'];
  stocks: Scalars['Boolean'];
};

export type QuestionnaireKnownInvestmentServices = {
  advice: Scalars['Boolean'];
  another: Scalars['Boolean'];
  funds: Scalars['Boolean'];
  none: Scalars['Boolean'];
  portfolio: Scalars['Boolean'];
  specification?: Maybe<Scalars['String']>;
};

export type QuestionnaireKnownInvestmentServicesModel = {
  __typename?: 'QuestionnaireKnownInvestmentServicesModel';
  advice: Scalars['Boolean'];
  another: Scalars['Boolean'];
  funds: Scalars['Boolean'];
  none: Scalars['Boolean'];
  portfolio: Scalars['Boolean'];
  specification?: Maybe<Scalars['String']>;
};

export type QuestionnaireKnownInvestmentTools = {
  bonds: Scalars['Boolean'];
  none: Scalars['Boolean'];
  securities: Scalars['Boolean'];
  specification?: Maybe<Scalars['String']>;
  stocks: Scalars['Boolean'];
};

export type QuestionnaireKnownInvestmentToolsModel = {
  __typename?: 'QuestionnaireKnownInvestmentToolsModel';
  bonds: Scalars['Boolean'];
  none: Scalars['Boolean'];
  securities: Scalars['Boolean'];
  specification?: Maybe<Scalars['String']>;
  stocks: Scalars['Boolean'];
};

export type QuestionnaireModel = {
  __typename?: 'QuestionnaireModel';
  dealAmount?: Maybe<Scalars['String']>;
  dealFrequency?: Maybe<Scalars['String']>;
  dealType?: Maybe<QuestionnaireDealTypeModel>;
  experienceLength?: Maybe<Scalars['String']>;
  knowledgeLevel?: Maybe<Scalars['String']>;
  knownInvestmentServices: QuestionnaireKnownInvestmentServicesModel;
  knownInvestmentTools: QuestionnaireKnownInvestmentToolsModel;
  points?: Maybe<Scalars['Float']>;
  profileType?: Maybe<Questionnaire_Profile_Types>;
  refuseFilling: Scalars['Boolean'];
  workingExperience?: Maybe<QuestionnaireWorkingExperienceModel>;
};

export type QuestionnaireV2DealType = {
  bonds: Scalars['Boolean'];
  derivatives: Scalars['Boolean'];
  securities: Scalars['Boolean'];
  stocks: Scalars['Boolean'];
};

export type QuestionnaireV2DealTypeModel = {
  __typename?: 'QuestionnaireV2DealTypeModel';
  bonds: Scalars['Boolean'];
  derivatives: Scalars['Boolean'];
  securities: Scalars['Boolean'];
  stocks: Scalars['Boolean'];
};

export type QuestionnaireV2HigherEductionInput = {
  exam: Scalars['Boolean'];
  no: Scalars['Boolean'];
  yes: Scalars['Boolean'];
};

export type QuestionnaireV2HigherEductionModel = {
  __typename?: 'QuestionnaireV2HigherEductionModel';
  exam: Scalars['Boolean'];
  no: Scalars['Boolean'];
  yes: Scalars['Boolean'];
};

export type QuestionnaireV2Model = {
  __typename?: 'QuestionnaireV2Model';
  bondsAre?: Maybe<Scalars['String']>;
  collectiveInvestmentsBenefits?: Maybe<Scalars['String']>;
  collectiveInvestmentsYouGetting?: Maybe<Scalars['String']>;
  dealAmount?: Maybe<Scalars['String']>;
  dealFrequency?: Maybe<Scalars['String']>;
  dealType?: Maybe<QuestionnaireV2DealTypeModel>;
  differenceBetweenInvestmentConsultingAndMediatingInvestments?: Maybe<Scalars['String']>;
  experienceLength?: Maybe<Scalars['String']>;
  experiencePoints?: Maybe<Scalars['Float']>;
  higherEducation?: Maybe<QuestionnaireV2HigherEductionModel>;
  investmentRelationProfession?: Maybe<Scalars['String']>;
  investmentShareCharacteristics?: Maybe<Scalars['String']>;
  knowledgePoints?: Maybe<Scalars['Float']>;
  profileType?: Maybe<Questionnaire_Profile_Types>;
  refuseFilling: Scalars['Boolean'];
  relationRiskAndReturn?: Maybe<Scalars['String']>;
  shareCertificateCharacteristics?: Maybe<Scalars['String']>;
  totalPoints?: Maybe<Scalars['Float']>;
};

export type QuestionnaireWorkingExperience = {
  none: Scalars['Boolean'];
  stocks: Scalars['Boolean'];
  stocksSpecification?: Maybe<Scalars['String']>;
  yes: Scalars['Boolean'];
  yesSpecification?: Maybe<Scalars['String']>;
};

export type QuestionnaireWorkingExperienceModel = {
  __typename?: 'QuestionnaireWorkingExperienceModel';
  none: Scalars['Boolean'];
  stocks: Scalars['Boolean'];
  stocksSpecification?: Maybe<Scalars['String']>;
  yes: Scalars['Boolean'];
  yesSpecification?: Maybe<Scalars['String']>;
};

export enum Sex {
  Female = 'female',
  Male = 'male'
}

export type SourceOfIncome = {
  companyName?: Maybe<Scalars['String']>;
  ic?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['String']>;
  specification?: Maybe<Scalars['String']>;
  subject?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

export type SourceOfIncomeDeal = {
  specification?: Maybe<SourceOfIncomeDealSpecification>;
  value: Scalars['String'];
};

export type SourceOfIncomeDealInput = {
  specification?: Maybe<SourceOfIncomeDealSpecificationInput>;
  value: Scalars['String'];
};

export type SourceOfIncomeDealModel = {
  __typename?: 'SourceOfIncomeDealModel';
  specification?: Maybe<SourceOfIncomeDealSpecificationModel>;
  value: Scalars['String'];
};

export type SourceOfIncomeDealSpecification = {
  bankName?: Maybe<Scalars['String']>;
  company?: Maybe<Scalars['String']>;
  ic?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  place?: Maybe<Scalars['String']>;
  relation?: Maybe<Scalars['String']>;
  specification?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

export type SourceOfIncomeDealSpecificationInput = {
  bankName?: Maybe<Scalars['String']>;
  company?: Maybe<Scalars['String']>;
  ic?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  place?: Maybe<Scalars['String']>;
  relation?: Maybe<Scalars['String']>;
  specification?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type SourceOfIncomeDealSpecificationModel = {
  __typename?: 'SourceOfIncomeDealSpecificationModel';
  bankName?: Maybe<Scalars['String']>;
  company?: Maybe<Scalars['String']>;
  ic?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  place?: Maybe<Scalars['String']>;
  relation?: Maybe<Scalars['String']>;
  specification?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type SourceOfIncomeDealUpdate = {
  specification?: Maybe<SourceOfIncomeDealSpecification>;
  value?: Maybe<Scalars['String']>;
};

export type SourceOfIncomeModel = {
  __typename?: 'SourceOfIncomeModel';
  companyName?: Maybe<Scalars['String']>;
  ic?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['String']>;
  specification?: Maybe<Scalars['String']>;
  subject?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type SourceOfIncomeUpdate = {
  companyName?: Maybe<Scalars['String']>;
  ic?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['String']>;
  specification?: Maybe<Scalars['String']>;
  subject?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export enum Target_Market_Result {
  In = 'IN',
  Negative = 'NEGATIVE',
  Out = 'OUT'
}

export type TargetMarketInput = {
  behavior: Scalars['String'];
  category: Scalars['String'];
  experience?: Maybe<Scalars['String']>;
  financialSituation: Scalars['String'];
  horizon: Scalars['String'];
  percentEstimate: Scalars['String'];
  product: Scalars['String'];
  relationship: Scalars['String'];
  sustainability: Scalars['String'];
  targets: Scalars['String'];
  targetsSpecification?: Maybe<Scalars['String']>;
  tweaking: Scalars['String'];
};

export type TargetMarketModel = {
  __typename?: 'TargetMarketModel';
  behavior: Scalars['String'];
  category: Scalars['String'];
  experience?: Maybe<Scalars['String']>;
  financialSituation: Scalars['String'];
  horizon: Scalars['String'];
  percentEstimate?: Maybe<Scalars['String']>;
  product?: Maybe<Scalars['String']>;
  relationship: Scalars['String'];
  sustainability?: Maybe<Scalars['String']>;
  targets: Scalars['String'];
  targetsSpecification?: Maybe<Scalars['String']>;
  tweaking: Scalars['String'];
};

export type TargetMarketUpdateInput = {
  behavior?: Maybe<Scalars['String']>;
  category?: Maybe<Scalars['String']>;
  experience?: Maybe<Scalars['String']>;
  financialSituation?: Maybe<Scalars['String']>;
  horizon?: Maybe<Scalars['String']>;
  percentEstimate?: Maybe<Scalars['String']>;
  product?: Maybe<Scalars['String']>;
  relationship?: Maybe<Scalars['String']>;
  sustainability?: Maybe<Scalars['String']>;
  targets?: Maybe<Scalars['String']>;
  targetsSpecification?: Maybe<Scalars['String']>;
  tweaking?: Maybe<Scalars['String']>;
};


export enum Validation_Type {
  Manual = 'MANUAL',
  Sms = 'SMS'
}

export type Questionnaire = QuestionnaireModel | QuestionnaireV2Model;

export type CircumstanceFragment = { __typename?: 'ContractCircumstanceModel', refusalOfIdentification: boolean, refusalOfCooperation: boolean, propertyConviction: boolean, propertyProsecution: boolean, refusalToProveWarrant: boolean, veracityOfData: boolean, fictitiousDocuments: boolean, suspiciousDeal: boolean, spareDocument: boolean, exposedPersonRelationship: boolean, lowIncomeShareHolder: boolean, absenceOfFaceToFaceIdentification: boolean, shareHolderConsultantRelation: boolean, fundamentalistPersonRelationship: boolean, nervousBehavior: boolean, selectsRemoteConsultant: boolean, withdrawalContractInterest: boolean, shareHolderIsInHurry: boolean, recordKeepingInterest: boolean, thirdPersonAttendance: boolean, notActingHimself: boolean, nonStandardReward: boolean, cantProvideBusinessScopeInformation: boolean, specification?: Maybe<string>, remoteMeeting: boolean };

export type GetContractConsultantQueryVariables = Exact<{
  code: Scalars['String'];
  consultantToken: Scalars['String'];
}>;


export type GetContractConsultantQuery = { __typename?: 'Query', contractConsultant: { __typename?: 'ContractConsultantModel', id: number, consultantSmsVerified?: Maybe<any>, circumstance?: Maybe<(
      { __typename?: 'ContractCircumstanceModel' }
      & CircumstanceFragment
    )>, products?: Maybe<Array<(
      { __typename?: 'ContractProductModel' }
      & ProductFragment
    )>> } };

export type CouponsFragment = { __typename?: 'ContractCouponsModel', uuid: string, discount: boolean, value?: Maybe<string>, duration?: Maybe<string> };

export type ProductFragment = { __typename?: 'ContractProductModel', uuid: string, investmentEstimatedAmount?: Maybe<number>, monthlyInvestmentAmount?: Maybe<number>, targetInvestmentAmount?: Maybe<number>, paymentMethodEntryFee?: Maybe<Payment_Method_Entry_Fee>, investmentType?: Maybe<{ __typename?: 'ContractInvestmentTypeModel', uuid: string, code: string, name: string }>, coupon?: Maybe<(
    { __typename?: 'ContractCouponsModel' }
    & CouponsFragment
  )> };

export type SendConsultantCodeQueryVariables = Exact<{
  code: Scalars['String'];
  consultantToken: Scalars['String'];
}>;


export type SendConsultantCodeQuery = { __typename?: 'Query', contractConsultantSendSms: boolean };

export type UpdateCircumstanceMutationVariables = Exact<{
  code: Scalars['String'];
  consultantToken: Scalars['String'];
  data: CircumstanceInput;
}>;


export type UpdateCircumstanceMutation = { __typename?: 'Mutation', contractConsultantUpdateCircumstance: (
    { __typename?: 'ContractCircumstanceModel' }
    & CircumstanceFragment
  ) };

export type UpdateCouponsMutationVariables = Exact<{
  code: Scalars['String'];
  consultantToken: Scalars['String'];
  data: ContractCouponsInput;
}>;


export type UpdateCouponsMutation = { __typename?: 'Mutation', contractConsultantUpdateCoupons: (
    { __typename?: 'ContractCouponsModel' }
    & CouponsFragment
  ) };

export type UpdateCouponsV2MutationVariables = Exact<{
  code: Scalars['String'];
  consultantToken: Scalars['String'];
  data: Array<ContractCouponsInputV2> | ContractCouponsInputV2;
}>;


export type UpdateCouponsV2Mutation = { __typename?: 'Mutation', contractConsultantUpdateCouponsV2: Array<(
    { __typename?: 'ContractCouponsModel' }
    & CouponsFragment
  )> };

export type VerifyConsultantSmsMutationVariables = Exact<{
  code: Scalars['String'];
  consultantToken: Scalars['String'];
  smsCode: Scalars['String'];
}>;


export type VerifyConsultantSmsMutation = { __typename?: 'Mutation', contractConsultantVerifySms: boolean };

export type GetCompaniesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCompaniesQuery = { __typename?: 'Query', getCompanies: Array<{ __typename?: 'ConsultantCompanyModelBase', uuid: string, name: string, private: boolean, tesla: boolean, isAvailableSporoRegular: boolean }> };

export type GetContractConsultantTokenQueryVariables = Exact<{
  code: Scalars['String'];
}>;


export type GetContractConsultantTokenQuery = { __typename?: 'Query', contractConsultantToken: string };

export type ContractFragment = (
  { __typename?: 'ContractModel', id: number, code: string, smsVerified: boolean, questionnaireVersion: number, isDraft: boolean, createdEmailSent?: Maybe<any> }
  & AmlFragment
);

export type ConsultantFragment = { __typename?: 'ContractModel', consultant?: Maybe<{ __typename?: 'ConsultantModel', id?: Maybe<string>, name: string, lastName: string, email: string, phone: string, place: string, businessName?: Maybe<string>, company: { __typename?: 'ConsultantCompanyModelBase', uuid: string, isAvailableSporoRegular: boolean } }> };

export type CustomerFragment = { __typename?: 'ContractModel', customer: { __typename?: 'CustomerModel', type: Investor_Type, sex: Sex, name: string, lastName: string, businessName?: Maybe<string>, id: string, ico?: Maybe<string>, dic?: Maybe<string>, birthPlace: string, birthCountry: string, address: { __typename?: 'CustomerAddressModel', city: string, code: string, country: string, street: string }, contactAddress?: Maybe<{ __typename?: 'CustomerAddressModel', city: string, code: string, country: string, street: string }>, foreign?: Maybe<{ __typename?: 'ForeignModel', id: string, birthPlace: string, taxDomicile: string }>, acting?: Maybe<{ __typename?: 'CustomerBaseModel', id: string, name: string, lastName: string, sex: Sex, birthPlace: string, birthCountry: string, address: { __typename?: 'CustomerAddressModel', city: string, code: string, country: string, street: string }, document?: Maybe<{ __typename?: 'DocumentModel', type: Document_Type, citizen: string, issuedBy: string, no: string, taxResident: string, validity: string }> }>, contact: { __typename?: 'ContactModel', bankCode?: Maybe<string>, bankAccount?: Maybe<string>, bankAccountConfirmation?: Maybe<boolean>, email: string, phone: string }, document?: Maybe<{ __typename?: 'DocumentModel', type: Document_Type, citizen: string, issuedBy: string, no: string, taxResident: string, validity: string }> } };

export type QuestionnaireFragment = { __typename?: 'ContractModel', questionnaire?: Maybe<{ __typename?: 'QuestionnaireModel', refuseFilling: boolean, knowledgeLevel?: Maybe<string>, experienceLength?: Maybe<string>, dealFrequency?: Maybe<string>, dealAmount?: Maybe<string>, knownInvestmentTools: { __typename?: 'QuestionnaireKnownInvestmentToolsModel', none: boolean, bonds: boolean, securities: boolean, stocks: boolean, specification?: Maybe<string> }, knownInvestmentServices: { __typename?: 'QuestionnaireKnownInvestmentServicesModel', none: boolean, funds: boolean, portfolio: boolean, advice: boolean, another: boolean, specification?: Maybe<string> }, workingExperience?: Maybe<{ __typename?: 'QuestionnaireWorkingExperienceModel', none: boolean, yes: boolean, yesSpecification?: Maybe<string>, stocks: boolean, stocksSpecification?: Maybe<string> }>, dealType?: Maybe<{ __typename?: 'QuestionnaireDealTypeModel', bonds: boolean, securities: boolean, stocks: boolean, derivatives: boolean }> } | { __typename?: 'QuestionnaireV2Model', refuseFilling: boolean, relationRiskAndReturn?: Maybe<string>, bondsAre?: Maybe<string>, collectiveInvestmentsBenefits?: Maybe<string>, collectiveInvestmentsYouGetting?: Maybe<string>, shareCertificateCharacteristics?: Maybe<string>, investmentShareCharacteristics?: Maybe<string>, investmentRelationProfession?: Maybe<string>, differenceBetweenInvestmentConsultingAndMediatingInvestments?: Maybe<string>, experienceLength?: Maybe<string>, dealFrequency?: Maybe<string>, dealAmount?: Maybe<string>, higherEducation?: Maybe<{ __typename?: 'QuestionnaireV2HigherEductionModel', no: boolean, yes: boolean, exam: boolean }>, dealType?: Maybe<{ __typename?: 'QuestionnaireV2DealTypeModel', bonds: boolean, securities: boolean, stocks: boolean, derivatives: boolean }> }> };

export type TargetMarketFragment = { __typename?: 'ContractModel', targetMarket?: Maybe<{ __typename?: 'TargetMarketModel', category: string, targets: string, targetsSpecification?: Maybe<string>, horizon: string, tweaking: string, financialSituation: string, relationship: string, behavior: string, product?: Maybe<string>, percentEstimate?: Maybe<string>, sustainability?: Maybe<string> }> };

export type AmlFragment = { __typename?: 'ContractModel', aml?: Maybe<{ __typename?: 'AMLModel', annualIncome: string, sourceOfIncome: { __typename?: 'SourceOfIncomeModel', value?: Maybe<string>, ic?: Maybe<string>, companyName?: Maybe<string>, position?: Maybe<string>, subject?: Maybe<string>, specification?: Maybe<string> }, sourceOfIncomeDeal: { __typename?: 'SourceOfIncomeDealModel', value: string, specification?: Maybe<{ __typename?: 'SourceOfIncomeDealSpecificationModel', value?: Maybe<string>, company?: Maybe<string>, ic?: Maybe<string>, place?: Maybe<string>, name?: Maybe<string>, relation?: Maybe<string>, bankName?: Maybe<string>, specification?: Maybe<string> }> }, purposeOfIncome: { __typename?: 'PurposeOfIncomeModel', value: string, specification?: Maybe<string> }, originOfProperty?: Maybe<{ __typename?: 'OriginOfPropertyModel', value: string, specification?: Maybe<string> }>, investorPoliticalDeclaration?: Maybe<{ __typename?: 'PoliticalDeclaration', pep?: Maybe<boolean>, penalty?: Maybe<boolean> }>, investorRepresentativePoliticalDeclaration?: Maybe<{ __typename?: 'PoliticalDeclaration', pep?: Maybe<boolean>, penalty?: Maybe<boolean> }>, investorDeclares?: Maybe<{ __typename?: 'InvestorDeclaresModel', residentOfCurrentCountry?: Maybe<boolean>, citizenAnotherCountry?: Maybe<boolean>, citizenAnotherCountrySpec?: Maybe<string>, residentAnotherCountry?: Maybe<boolean>, residentAnotherCountrySpec?: Maybe<string>, corporateAnotherCountry?: Maybe<boolean>, corporateAnotherCountrySpec?: Maybe<string> }>, investorRepresentativeDeclares?: Maybe<{ __typename?: 'InvestorDeclaresModel', residentOfCurrentCountry?: Maybe<boolean>, citizenAnotherCountry?: Maybe<boolean>, citizenAnotherCountrySpec?: Maybe<string>, residentAnotherCountry?: Maybe<boolean>, residentAnotherCountrySpec?: Maybe<string>, corporateAnotherCountry?: Maybe<boolean>, corporateAnotherCountrySpec?: Maybe<string> }> }> };

export type DocumentsFragment = { __typename?: 'ContractModel', documents?: Maybe<Array<{ __typename?: 'DocumentFileModel', uuid: string, name: string, type: Document_Type, path: string }>> };

export type CommunicationFragment = { __typename?: 'ContractModel', communication?: Maybe<{ __typename?: 'DealCommunication', information: boolean, email: boolean, remoteControl: boolean }> };

export type ProductsFragment = { __typename?: 'ContractModel', products?: Maybe<Array<{ __typename?: 'ContractProductModel', uuid: string, investmentEstimatedAmount?: Maybe<number>, targetInvestmentAmount?: Maybe<number>, monthlyInvestmentAmount?: Maybe<number>, paymentMethodEntryFee?: Maybe<Payment_Method_Entry_Fee>, investmentType?: Maybe<{ __typename?: 'ContractInvestmentTypeModel', uuid: string, name: string, code: string }> }>> };

export type GetContractQueryVariables = Exact<{
  code: Scalars['String'];
}>;


export type GetContractQuery = { __typename?: 'Query', contract: (
    { __typename?: 'ContractModel', referral?: Maybe<string>, termsAndConditions: boolean, distributorTargetMarket?: Maybe<Target_Market_Result>, version?: Maybe<number> }
    & ProductsFragment
    & ConsultantFragment
    & ContractFragment
    & CustomerFragment
    & TargetMarketFragment
    & CommunicationFragment
    & QuestionnaireFragment
    & AmlFragment
    & DocumentsFragment
  ) };

export type CreateContractProposalMutationVariables = Exact<{
  code: Scalars['String'];
}>;


export type CreateContractProposalMutation = { __typename?: 'Mutation', createContractProposal: string };

export type CreateContractMutationVariables = Exact<{
  data: ContractInput;
}>;


export type CreateContractMutation = { __typename?: 'Mutation', createContract: { __typename?: 'ContractModel', id: number, code: string } };

export type GetEfolioOzQueryVariables = Exact<{
  efolioOzId: Scalars['String'];
}>;


export type GetEfolioOzQuery = { __typename?: 'Query', getEfolioOZ: { __typename?: 'ContractConsultantCompanyModel', id: string, name?: Maybe<string>, lastName?: Maybe<string>, phone?: Maybe<string>, email?: Maybe<string>, company?: Maybe<{ __typename?: 'ConsultantCompanyModelBase', uuid: string, name: string }> } };

export type GetInvestmentTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetInvestmentTypesQuery = { __typename?: 'Query', getInvestmentTypes: Array<{ __typename?: 'ContractInvestmentTypeModel', uuid: string, code: string, name: string }> };

export type PublishContractMutationVariables = Exact<{
  code: Scalars['String'];
}>;


export type PublishContractMutation = { __typename?: 'Mutation', publishContract: (
    { __typename?: 'ContractModel' }
    & ContractFragment
  ) };

export type SendDraftCreationEmailMutationVariables = Exact<{
  code: Scalars['String'];
}>;


export type SendDraftCreationEmailMutation = { __typename?: 'Mutation', sendDraftCreationEmail: (
    { __typename?: 'ContractModel' }
    & ContractFragment
  ) };

export type SendValidationSmsQueryVariables = Exact<{
  code: Scalars['String'];
  id: Scalars['Int'];
}>;


export type SendValidationSmsQuery = { __typename?: 'Query', sendValidationSMS: boolean };

export type UpdateContractMutationVariables = Exact<{
  id: Scalars['Int'];
  code: Scalars['String'];
  data: ContractUpdateInput;
}>;


export type UpdateContractMutation = { __typename?: 'Mutation', updateContract: (
    { __typename?: 'ContractModel' }
    & ContractFragment
  ) };

export type UpdateDocumentsMutationVariables = Exact<{
  id: Scalars['Int'];
  code: Scalars['String'];
  files: Array<DocumentFileInput> | DocumentFileInput;
}>;


export type UpdateDocumentsMutation = { __typename?: 'Mutation', updateDocuments: Array<{ __typename?: 'DocumentFileModel', uuid: string, name: string, type: Document_Type, path: string }> };

export type GetCompanyByIcQueryVariables = Exact<{
  ic: Scalars['String'];
}>;


export type GetCompanyByIcQuery = { __typename?: 'Query', getCompanyByIc: { __typename?: 'AresCompanyModel', name: string, ico: string, dic?: Maybe<string> } };

export type VerifyContractBySmsMutationVariables = Exact<{
  code: Scalars['String'];
  id: Scalars['Int'];
  verificationCode: Scalars['String'];
}>;


export type VerifyContractBySmsMutation = { __typename?: 'Mutation', verifyContractBySMS: boolean };

export type LoginMutationVariables = Exact<{
  password: Scalars['String'];
}>;


export type LoginMutation = { __typename?: 'Mutation', login: { __typename?: 'IdentityLoginModel', token: string } };

export type PartnerLoginMutationVariables = Exact<{
  phone: Scalars['String'];
}>;


export type PartnerLoginMutation = { __typename?: 'Mutation', partnerLogin: boolean };

export type PartnerLoginVerificationMutationVariables = Exact<{
  code: Scalars['String'];
}>;


export type PartnerLoginVerificationMutation = { __typename?: 'Mutation', partnerLoginVerification: { __typename?: 'IdentityLoginModel', token: string } };

export type VerifyQueryVariables = Exact<{
  token: Scalars['String'];
}>;


export type VerifyQuery = { __typename?: 'Query', verify: { __typename?: 'IdentityParsedToken', scope: Array<LoginScope>, iat: number, exp: number } };

export const CircumstanceFragmentDoc = gql`
    fragment Circumstance on ContractCircumstanceModel {
  refusalOfIdentification
  refusalOfCooperation
  propertyConviction
  propertyProsecution
  refusalToProveWarrant
  veracityOfData
  fictitiousDocuments
  suspiciousDeal
  spareDocument
  exposedPersonRelationship
  lowIncomeShareHolder
  absenceOfFaceToFaceIdentification
  shareHolderConsultantRelation
  fundamentalistPersonRelationship
  nervousBehavior
  selectsRemoteConsultant
  withdrawalContractInterest
  shareHolderIsInHurry
  recordKeepingInterest
  thirdPersonAttendance
  notActingHimself
  nonStandardReward
  cantProvideBusinessScopeInformation
  specification
  remoteMeeting
}
    `;
export const CouponsFragmentDoc = gql`
    fragment Coupons on ContractCouponsModel {
  uuid
  discount
  value
  duration
}
    `;
export const ProductFragmentDoc = gql`
    fragment Product on ContractProductModel {
  uuid
  investmentType {
    uuid
    code
    name
  }
  investmentEstimatedAmount
  monthlyInvestmentAmount
  targetInvestmentAmount
  paymentMethodEntryFee
  coupon {
    ...Coupons
  }
}
    ${CouponsFragmentDoc}`;
export const AmlFragmentDoc = gql`
    fragment aml on ContractModel {
  aml {
    sourceOfIncome {
      value
      ic
      companyName
      position
      subject
      specification
    }
    annualIncome
    sourceOfIncomeDeal {
      value
      specification {
        value
        company
        ic
        place
        name
        relation
        bankName
        specification
      }
    }
    purposeOfIncome {
      value
      specification
    }
    originOfProperty {
      value
      specification
    }
    investorPoliticalDeclaration {
      pep
      penalty
    }
    investorRepresentativePoliticalDeclaration {
      pep
      penalty
    }
    investorDeclares {
      residentOfCurrentCountry
      citizenAnotherCountry
      citizenAnotherCountrySpec
      residentAnotherCountry
      residentAnotherCountrySpec
      corporateAnotherCountry
      corporateAnotherCountrySpec
    }
    investorRepresentativeDeclares {
      residentOfCurrentCountry
      citizenAnotherCountry
      citizenAnotherCountrySpec
      residentAnotherCountry
      residentAnotherCountrySpec
      corporateAnotherCountry
      corporateAnotherCountrySpec
    }
  }
}
    `;
export const ContractFragmentDoc = gql`
    fragment contract on ContractModel {
  id
  code
  smsVerified
  questionnaireVersion
  isDraft
  createdEmailSent
  ...aml
}
    ${AmlFragmentDoc}`;
export const ConsultantFragmentDoc = gql`
    fragment consultant on ContractModel {
  consultant {
    id
    name
    lastName
    email
    phone
    company {
      uuid
      isAvailableSporoRegular
    }
    place
    businessName
  }
}
    `;
export const CustomerFragmentDoc = gql`
    fragment customer on ContractModel {
  customer {
    type
    sex
    name
    lastName
    businessName
    id
    ico
    dic
    birthPlace
    birthCountry
    address {
      city
      code
      country
      street
    }
    contactAddress {
      city
      code
      country
      street
    }
    foreign {
      id
      birthPlace
      taxDomicile
    }
    acting {
      id
      name
      lastName
      sex
      birthPlace
      birthCountry
      address {
        city
        code
        country
        street
      }
      document {
        type
        citizen
        issuedBy
        no
        taxResident
        validity
      }
    }
    contact {
      bankCode
      bankAccount
      bankAccountConfirmation
      email
      phone
    }
    document {
      type
      citizen
      issuedBy
      no
      taxResident
      validity
    }
  }
}
    `;
export const QuestionnaireFragmentDoc = gql`
    fragment questionnaire on ContractModel {
  questionnaire {
    ... on QuestionnaireModel {
      refuseFilling
      knownInvestmentTools {
        none
        bonds
        securities
        stocks
        specification
      }
      knownInvestmentServices {
        none
        funds
        portfolio
        advice
        another
        specification
      }
      knowledgeLevel
      experienceLength
      workingExperience {
        none
        yes
        yesSpecification
        stocks
        stocksSpecification
      }
      dealFrequency
      dealType {
        bonds
        securities
        stocks
        derivatives
      }
      dealAmount
    }
    ... on QuestionnaireV2Model {
      refuseFilling
      relationRiskAndReturn
      bondsAre
      collectiveInvestmentsBenefits
      collectiveInvestmentsYouGetting
      shareCertificateCharacteristics
      investmentShareCharacteristics
      investmentRelationProfession
      differenceBetweenInvestmentConsultingAndMediatingInvestments
      higherEducation {
        no
        yes
        exam
      }
      experienceLength
      dealFrequency
      dealType {
        bonds
        securities
        stocks
        derivatives
      }
      dealAmount
    }
  }
}
    `;
export const TargetMarketFragmentDoc = gql`
    fragment targetMarket on ContractModel {
  targetMarket {
    category
    targets
    targetsSpecification
    horizon
    tweaking
    financialSituation
    relationship
    behavior
    product
    percentEstimate
    sustainability
  }
}
    `;
export const DocumentsFragmentDoc = gql`
    fragment documents on ContractModel {
  documents {
    uuid
    name
    type
    path
  }
}
    `;
export const CommunicationFragmentDoc = gql`
    fragment communication on ContractModel {
  communication {
    information
    email
    remoteControl
  }
}
    `;
export const ProductsFragmentDoc = gql`
    fragment products on ContractModel {
  products {
    uuid
    investmentType {
      uuid
      name
      code
    }
    investmentEstimatedAmount
    targetInvestmentAmount
    monthlyInvestmentAmount
    paymentMethodEntryFee
  }
}
    `;
export const GetContractConsultantDocument = gql`
    query getContractConsultant($code: String!, $consultantToken: String!) {
  contractConsultant(code: $code, consultantToken: $consultantToken) {
    id
    circumstance {
      ...Circumstance
    }
    products {
      ...Product
    }
    consultantSmsVerified
  }
}
    ${CircumstanceFragmentDoc}
${ProductFragmentDoc}`;

/**
 * __useGetContractConsultantQuery__
 *
 * To run a query within a React component, call `useGetContractConsultantQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContractConsultantQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContractConsultantQuery({
 *   variables: {
 *      code: // value for 'code'
 *      consultantToken: // value for 'consultantToken'
 *   },
 * });
 */
export function useGetContractConsultantQuery(baseOptions: Apollo.QueryHookOptions<GetContractConsultantQuery, GetContractConsultantQueryVariables>) {
        return Apollo.useQuery<GetContractConsultantQuery, GetContractConsultantQueryVariables>(GetContractConsultantDocument, baseOptions);
      }
export function useGetContractConsultantLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContractConsultantQuery, GetContractConsultantQueryVariables>) {
          return Apollo.useLazyQuery<GetContractConsultantQuery, GetContractConsultantQueryVariables>(GetContractConsultantDocument, baseOptions);
        }
export type GetContractConsultantQueryHookResult = ReturnType<typeof useGetContractConsultantQuery>;
export type GetContractConsultantLazyQueryHookResult = ReturnType<typeof useGetContractConsultantLazyQuery>;
export type GetContractConsultantQueryResult = Apollo.QueryResult<GetContractConsultantQuery, GetContractConsultantQueryVariables>;
export const SendConsultantCodeDocument = gql`
    query sendConsultantCode($code: String!, $consultantToken: String!) {
  contractConsultantSendSms(code: $code, consultantToken: $consultantToken)
}
    `;

/**
 * __useSendConsultantCodeQuery__
 *
 * To run a query within a React component, call `useSendConsultantCodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useSendConsultantCodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSendConsultantCodeQuery({
 *   variables: {
 *      code: // value for 'code'
 *      consultantToken: // value for 'consultantToken'
 *   },
 * });
 */
export function useSendConsultantCodeQuery(baseOptions: Apollo.QueryHookOptions<SendConsultantCodeQuery, SendConsultantCodeQueryVariables>) {
        return Apollo.useQuery<SendConsultantCodeQuery, SendConsultantCodeQueryVariables>(SendConsultantCodeDocument, baseOptions);
      }
export function useSendConsultantCodeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SendConsultantCodeQuery, SendConsultantCodeQueryVariables>) {
          return Apollo.useLazyQuery<SendConsultantCodeQuery, SendConsultantCodeQueryVariables>(SendConsultantCodeDocument, baseOptions);
        }
export type SendConsultantCodeQueryHookResult = ReturnType<typeof useSendConsultantCodeQuery>;
export type SendConsultantCodeLazyQueryHookResult = ReturnType<typeof useSendConsultantCodeLazyQuery>;
export type SendConsultantCodeQueryResult = Apollo.QueryResult<SendConsultantCodeQuery, SendConsultantCodeQueryVariables>;
export const UpdateCircumstanceDocument = gql`
    mutation updateCircumstance($code: String!, $consultantToken: String!, $data: CircumstanceInput!) {
  contractConsultantUpdateCircumstance(
    code: $code
    consultantToken: $consultantToken
    data: $data
  ) {
    ...Circumstance
  }
}
    ${CircumstanceFragmentDoc}`;
export type UpdateCircumstanceMutationFn = Apollo.MutationFunction<UpdateCircumstanceMutation, UpdateCircumstanceMutationVariables>;

/**
 * __useUpdateCircumstanceMutation__
 *
 * To run a mutation, you first call `useUpdateCircumstanceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCircumstanceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCircumstanceMutation, { data, loading, error }] = useUpdateCircumstanceMutation({
 *   variables: {
 *      code: // value for 'code'
 *      consultantToken: // value for 'consultantToken'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateCircumstanceMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCircumstanceMutation, UpdateCircumstanceMutationVariables>) {
        return Apollo.useMutation<UpdateCircumstanceMutation, UpdateCircumstanceMutationVariables>(UpdateCircumstanceDocument, baseOptions);
      }
export type UpdateCircumstanceMutationHookResult = ReturnType<typeof useUpdateCircumstanceMutation>;
export type UpdateCircumstanceMutationResult = Apollo.MutationResult<UpdateCircumstanceMutation>;
export type UpdateCircumstanceMutationOptions = Apollo.BaseMutationOptions<UpdateCircumstanceMutation, UpdateCircumstanceMutationVariables>;
export const UpdateCouponsDocument = gql`
    mutation updateCoupons($code: String!, $consultantToken: String!, $data: ContractCouponsInput!) {
  contractConsultantUpdateCoupons(
    code: $code
    consultantToken: $consultantToken
    data: $data
  ) {
    ...Coupons
  }
}
    ${CouponsFragmentDoc}`;
export type UpdateCouponsMutationFn = Apollo.MutationFunction<UpdateCouponsMutation, UpdateCouponsMutationVariables>;

/**
 * __useUpdateCouponsMutation__
 *
 * To run a mutation, you first call `useUpdateCouponsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCouponsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCouponsMutation, { data, loading, error }] = useUpdateCouponsMutation({
 *   variables: {
 *      code: // value for 'code'
 *      consultantToken: // value for 'consultantToken'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateCouponsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCouponsMutation, UpdateCouponsMutationVariables>) {
        return Apollo.useMutation<UpdateCouponsMutation, UpdateCouponsMutationVariables>(UpdateCouponsDocument, baseOptions);
      }
export type UpdateCouponsMutationHookResult = ReturnType<typeof useUpdateCouponsMutation>;
export type UpdateCouponsMutationResult = Apollo.MutationResult<UpdateCouponsMutation>;
export type UpdateCouponsMutationOptions = Apollo.BaseMutationOptions<UpdateCouponsMutation, UpdateCouponsMutationVariables>;
export const UpdateCouponsV2Document = gql`
    mutation updateCouponsV2($code: String!, $consultantToken: String!, $data: [ContractCouponsInputV2!]!) {
  contractConsultantUpdateCouponsV2(
    code: $code
    consultantToken: $consultantToken
    data: $data
  ) {
    ...Coupons
  }
}
    ${CouponsFragmentDoc}`;
export type UpdateCouponsV2MutationFn = Apollo.MutationFunction<UpdateCouponsV2Mutation, UpdateCouponsV2MutationVariables>;

/**
 * __useUpdateCouponsV2Mutation__
 *
 * To run a mutation, you first call `useUpdateCouponsV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCouponsV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCouponsV2Mutation, { data, loading, error }] = useUpdateCouponsV2Mutation({
 *   variables: {
 *      code: // value for 'code'
 *      consultantToken: // value for 'consultantToken'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateCouponsV2Mutation(baseOptions?: Apollo.MutationHookOptions<UpdateCouponsV2Mutation, UpdateCouponsV2MutationVariables>) {
        return Apollo.useMutation<UpdateCouponsV2Mutation, UpdateCouponsV2MutationVariables>(UpdateCouponsV2Document, baseOptions);
      }
export type UpdateCouponsV2MutationHookResult = ReturnType<typeof useUpdateCouponsV2Mutation>;
export type UpdateCouponsV2MutationResult = Apollo.MutationResult<UpdateCouponsV2Mutation>;
export type UpdateCouponsV2MutationOptions = Apollo.BaseMutationOptions<UpdateCouponsV2Mutation, UpdateCouponsV2MutationVariables>;
export const VerifyConsultantSmsDocument = gql`
    mutation verifyConsultantSms($code: String!, $consultantToken: String!, $smsCode: String!) {
  contractConsultantVerifySms(
    code: $code
    consultantToken: $consultantToken
    smsCode: $smsCode
  )
}
    `;
export type VerifyConsultantSmsMutationFn = Apollo.MutationFunction<VerifyConsultantSmsMutation, VerifyConsultantSmsMutationVariables>;

/**
 * __useVerifyConsultantSmsMutation__
 *
 * To run a mutation, you first call `useVerifyConsultantSmsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyConsultantSmsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyConsultantSmsMutation, { data, loading, error }] = useVerifyConsultantSmsMutation({
 *   variables: {
 *      code: // value for 'code'
 *      consultantToken: // value for 'consultantToken'
 *      smsCode: // value for 'smsCode'
 *   },
 * });
 */
export function useVerifyConsultantSmsMutation(baseOptions?: Apollo.MutationHookOptions<VerifyConsultantSmsMutation, VerifyConsultantSmsMutationVariables>) {
        return Apollo.useMutation<VerifyConsultantSmsMutation, VerifyConsultantSmsMutationVariables>(VerifyConsultantSmsDocument, baseOptions);
      }
export type VerifyConsultantSmsMutationHookResult = ReturnType<typeof useVerifyConsultantSmsMutation>;
export type VerifyConsultantSmsMutationResult = Apollo.MutationResult<VerifyConsultantSmsMutation>;
export type VerifyConsultantSmsMutationOptions = Apollo.BaseMutationOptions<VerifyConsultantSmsMutation, VerifyConsultantSmsMutationVariables>;
export const GetCompaniesDocument = gql`
    query getCompanies {
  getCompanies {
    uuid
    name
    private
    tesla
    isAvailableSporoRegular
  }
}
    `;

/**
 * __useGetCompaniesQuery__
 *
 * To run a query within a React component, call `useGetCompaniesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompaniesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompaniesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCompaniesQuery(baseOptions?: Apollo.QueryHookOptions<GetCompaniesQuery, GetCompaniesQueryVariables>) {
        return Apollo.useQuery<GetCompaniesQuery, GetCompaniesQueryVariables>(GetCompaniesDocument, baseOptions);
      }
export function useGetCompaniesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCompaniesQuery, GetCompaniesQueryVariables>) {
          return Apollo.useLazyQuery<GetCompaniesQuery, GetCompaniesQueryVariables>(GetCompaniesDocument, baseOptions);
        }
export type GetCompaniesQueryHookResult = ReturnType<typeof useGetCompaniesQuery>;
export type GetCompaniesLazyQueryHookResult = ReturnType<typeof useGetCompaniesLazyQuery>;
export type GetCompaniesQueryResult = Apollo.QueryResult<GetCompaniesQuery, GetCompaniesQueryVariables>;
export const GetContractConsultantTokenDocument = gql`
    query getContractConsultantToken($code: String!) {
  contractConsultantToken(code: $code)
}
    `;

/**
 * __useGetContractConsultantTokenQuery__
 *
 * To run a query within a React component, call `useGetContractConsultantTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContractConsultantTokenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContractConsultantTokenQuery({
 *   variables: {
 *      code: // value for 'code'
 *   },
 * });
 */
export function useGetContractConsultantTokenQuery(baseOptions: Apollo.QueryHookOptions<GetContractConsultantTokenQuery, GetContractConsultantTokenQueryVariables>) {
        return Apollo.useQuery<GetContractConsultantTokenQuery, GetContractConsultantTokenQueryVariables>(GetContractConsultantTokenDocument, baseOptions);
      }
export function useGetContractConsultantTokenLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContractConsultantTokenQuery, GetContractConsultantTokenQueryVariables>) {
          return Apollo.useLazyQuery<GetContractConsultantTokenQuery, GetContractConsultantTokenQueryVariables>(GetContractConsultantTokenDocument, baseOptions);
        }
export type GetContractConsultantTokenQueryHookResult = ReturnType<typeof useGetContractConsultantTokenQuery>;
export type GetContractConsultantTokenLazyQueryHookResult = ReturnType<typeof useGetContractConsultantTokenLazyQuery>;
export type GetContractConsultantTokenQueryResult = Apollo.QueryResult<GetContractConsultantTokenQuery, GetContractConsultantTokenQueryVariables>;
export const GetContractDocument = gql`
    query getContract($code: String!) {
  contract(code: $code) {
    referral
    termsAndConditions
    distributorTargetMarket
    version
    ...products
    ...consultant
    ...contract
    ...customer
    ...targetMarket
    ...communication
    ...questionnaire
    ...aml
    ...documents
  }
}
    ${ProductsFragmentDoc}
${ConsultantFragmentDoc}
${ContractFragmentDoc}
${CustomerFragmentDoc}
${TargetMarketFragmentDoc}
${CommunicationFragmentDoc}
${QuestionnaireFragmentDoc}
${AmlFragmentDoc}
${DocumentsFragmentDoc}`;

/**
 * __useGetContractQuery__
 *
 * To run a query within a React component, call `useGetContractQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContractQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContractQuery({
 *   variables: {
 *      code: // value for 'code'
 *   },
 * });
 */
export function useGetContractQuery(baseOptions: Apollo.QueryHookOptions<GetContractQuery, GetContractQueryVariables>) {
        return Apollo.useQuery<GetContractQuery, GetContractQueryVariables>(GetContractDocument, baseOptions);
      }
export function useGetContractLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContractQuery, GetContractQueryVariables>) {
          return Apollo.useLazyQuery<GetContractQuery, GetContractQueryVariables>(GetContractDocument, baseOptions);
        }
export type GetContractQueryHookResult = ReturnType<typeof useGetContractQuery>;
export type GetContractLazyQueryHookResult = ReturnType<typeof useGetContractLazyQuery>;
export type GetContractQueryResult = Apollo.QueryResult<GetContractQuery, GetContractQueryVariables>;
export const CreateContractProposalDocument = gql`
    mutation createContractProposal($code: String!) {
  createContractProposal(code: $code)
}
    `;
export type CreateContractProposalMutationFn = Apollo.MutationFunction<CreateContractProposalMutation, CreateContractProposalMutationVariables>;

/**
 * __useCreateContractProposalMutation__
 *
 * To run a mutation, you first call `useCreateContractProposalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateContractProposalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createContractProposalMutation, { data, loading, error }] = useCreateContractProposalMutation({
 *   variables: {
 *      code: // value for 'code'
 *   },
 * });
 */
export function useCreateContractProposalMutation(baseOptions?: Apollo.MutationHookOptions<CreateContractProposalMutation, CreateContractProposalMutationVariables>) {
        return Apollo.useMutation<CreateContractProposalMutation, CreateContractProposalMutationVariables>(CreateContractProposalDocument, baseOptions);
      }
export type CreateContractProposalMutationHookResult = ReturnType<typeof useCreateContractProposalMutation>;
export type CreateContractProposalMutationResult = Apollo.MutationResult<CreateContractProposalMutation>;
export type CreateContractProposalMutationOptions = Apollo.BaseMutationOptions<CreateContractProposalMutation, CreateContractProposalMutationVariables>;
export const CreateContractDocument = gql`
    mutation createContract($data: ContractInput!) {
  createContract(data: $data) {
    id
    code
  }
}
    `;
export type CreateContractMutationFn = Apollo.MutationFunction<CreateContractMutation, CreateContractMutationVariables>;

/**
 * __useCreateContractMutation__
 *
 * To run a mutation, you first call `useCreateContractMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateContractMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createContractMutation, { data, loading, error }] = useCreateContractMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateContractMutation(baseOptions?: Apollo.MutationHookOptions<CreateContractMutation, CreateContractMutationVariables>) {
        return Apollo.useMutation<CreateContractMutation, CreateContractMutationVariables>(CreateContractDocument, baseOptions);
      }
export type CreateContractMutationHookResult = ReturnType<typeof useCreateContractMutation>;
export type CreateContractMutationResult = Apollo.MutationResult<CreateContractMutation>;
export type CreateContractMutationOptions = Apollo.BaseMutationOptions<CreateContractMutation, CreateContractMutationVariables>;
export const GetEfolioOzDocument = gql`
    query getEfolioOz($efolioOzId: String!) {
  getEfolioOZ(efolioOzId: $efolioOzId) {
    id
    name
    lastName
    phone
    email
    company {
      uuid
      name
    }
  }
}
    `;

/**
 * __useGetEfolioOzQuery__
 *
 * To run a query within a React component, call `useGetEfolioOzQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEfolioOzQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEfolioOzQuery({
 *   variables: {
 *      efolioOzId: // value for 'efolioOzId'
 *   },
 * });
 */
export function useGetEfolioOzQuery(baseOptions: Apollo.QueryHookOptions<GetEfolioOzQuery, GetEfolioOzQueryVariables>) {
        return Apollo.useQuery<GetEfolioOzQuery, GetEfolioOzQueryVariables>(GetEfolioOzDocument, baseOptions);
      }
export function useGetEfolioOzLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEfolioOzQuery, GetEfolioOzQueryVariables>) {
          return Apollo.useLazyQuery<GetEfolioOzQuery, GetEfolioOzQueryVariables>(GetEfolioOzDocument, baseOptions);
        }
export type GetEfolioOzQueryHookResult = ReturnType<typeof useGetEfolioOzQuery>;
export type GetEfolioOzLazyQueryHookResult = ReturnType<typeof useGetEfolioOzLazyQuery>;
export type GetEfolioOzQueryResult = Apollo.QueryResult<GetEfolioOzQuery, GetEfolioOzQueryVariables>;
export const GetInvestmentTypesDocument = gql`
    query getInvestmentTypes {
  getInvestmentTypes {
    uuid
    code
    name
  }
}
    `;

/**
 * __useGetInvestmentTypesQuery__
 *
 * To run a query within a React component, call `useGetInvestmentTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInvestmentTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInvestmentTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetInvestmentTypesQuery(baseOptions?: Apollo.QueryHookOptions<GetInvestmentTypesQuery, GetInvestmentTypesQueryVariables>) {
        return Apollo.useQuery<GetInvestmentTypesQuery, GetInvestmentTypesQueryVariables>(GetInvestmentTypesDocument, baseOptions);
      }
export function useGetInvestmentTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInvestmentTypesQuery, GetInvestmentTypesQueryVariables>) {
          return Apollo.useLazyQuery<GetInvestmentTypesQuery, GetInvestmentTypesQueryVariables>(GetInvestmentTypesDocument, baseOptions);
        }
export type GetInvestmentTypesQueryHookResult = ReturnType<typeof useGetInvestmentTypesQuery>;
export type GetInvestmentTypesLazyQueryHookResult = ReturnType<typeof useGetInvestmentTypesLazyQuery>;
export type GetInvestmentTypesQueryResult = Apollo.QueryResult<GetInvestmentTypesQuery, GetInvestmentTypesQueryVariables>;
export const PublishContractDocument = gql`
    mutation publishContract($code: String!) {
  publishContract(code: $code) {
    ...contract
  }
}
    ${ContractFragmentDoc}`;
export type PublishContractMutationFn = Apollo.MutationFunction<PublishContractMutation, PublishContractMutationVariables>;

/**
 * __usePublishContractMutation__
 *
 * To run a mutation, you first call `usePublishContractMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePublishContractMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [publishContractMutation, { data, loading, error }] = usePublishContractMutation({
 *   variables: {
 *      code: // value for 'code'
 *   },
 * });
 */
export function usePublishContractMutation(baseOptions?: Apollo.MutationHookOptions<PublishContractMutation, PublishContractMutationVariables>) {
        return Apollo.useMutation<PublishContractMutation, PublishContractMutationVariables>(PublishContractDocument, baseOptions);
      }
export type PublishContractMutationHookResult = ReturnType<typeof usePublishContractMutation>;
export type PublishContractMutationResult = Apollo.MutationResult<PublishContractMutation>;
export type PublishContractMutationOptions = Apollo.BaseMutationOptions<PublishContractMutation, PublishContractMutationVariables>;
export const SendDraftCreationEmailDocument = gql`
    mutation sendDraftCreationEmail($code: String!) {
  sendDraftCreationEmail(code: $code) {
    ...contract
  }
}
    ${ContractFragmentDoc}`;
export type SendDraftCreationEmailMutationFn = Apollo.MutationFunction<SendDraftCreationEmailMutation, SendDraftCreationEmailMutationVariables>;

/**
 * __useSendDraftCreationEmailMutation__
 *
 * To run a mutation, you first call `useSendDraftCreationEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendDraftCreationEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendDraftCreationEmailMutation, { data, loading, error }] = useSendDraftCreationEmailMutation({
 *   variables: {
 *      code: // value for 'code'
 *   },
 * });
 */
export function useSendDraftCreationEmailMutation(baseOptions?: Apollo.MutationHookOptions<SendDraftCreationEmailMutation, SendDraftCreationEmailMutationVariables>) {
        return Apollo.useMutation<SendDraftCreationEmailMutation, SendDraftCreationEmailMutationVariables>(SendDraftCreationEmailDocument, baseOptions);
      }
export type SendDraftCreationEmailMutationHookResult = ReturnType<typeof useSendDraftCreationEmailMutation>;
export type SendDraftCreationEmailMutationResult = Apollo.MutationResult<SendDraftCreationEmailMutation>;
export type SendDraftCreationEmailMutationOptions = Apollo.BaseMutationOptions<SendDraftCreationEmailMutation, SendDraftCreationEmailMutationVariables>;
export const SendValidationSmsDocument = gql`
    query sendValidationSMS($code: String!, $id: Int!) {
  sendValidationSMS(code: $code, id: $id)
}
    `;

/**
 * __useSendValidationSmsQuery__
 *
 * To run a query within a React component, call `useSendValidationSmsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSendValidationSmsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSendValidationSmsQuery({
 *   variables: {
 *      code: // value for 'code'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSendValidationSmsQuery(baseOptions: Apollo.QueryHookOptions<SendValidationSmsQuery, SendValidationSmsQueryVariables>) {
        return Apollo.useQuery<SendValidationSmsQuery, SendValidationSmsQueryVariables>(SendValidationSmsDocument, baseOptions);
      }
export function useSendValidationSmsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SendValidationSmsQuery, SendValidationSmsQueryVariables>) {
          return Apollo.useLazyQuery<SendValidationSmsQuery, SendValidationSmsQueryVariables>(SendValidationSmsDocument, baseOptions);
        }
export type SendValidationSmsQueryHookResult = ReturnType<typeof useSendValidationSmsQuery>;
export type SendValidationSmsLazyQueryHookResult = ReturnType<typeof useSendValidationSmsLazyQuery>;
export type SendValidationSmsQueryResult = Apollo.QueryResult<SendValidationSmsQuery, SendValidationSmsQueryVariables>;
export const UpdateContractDocument = gql`
    mutation updateContract($id: Int!, $code: String!, $data: ContractUpdateInput!) {
  updateContract(id: $id, code: $code, data: $data) {
    ...contract
  }
}
    ${ContractFragmentDoc}`;
export type UpdateContractMutationFn = Apollo.MutationFunction<UpdateContractMutation, UpdateContractMutationVariables>;

/**
 * __useUpdateContractMutation__
 *
 * To run a mutation, you first call `useUpdateContractMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateContractMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateContractMutation, { data, loading, error }] = useUpdateContractMutation({
 *   variables: {
 *      id: // value for 'id'
 *      code: // value for 'code'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateContractMutation(baseOptions?: Apollo.MutationHookOptions<UpdateContractMutation, UpdateContractMutationVariables>) {
        return Apollo.useMutation<UpdateContractMutation, UpdateContractMutationVariables>(UpdateContractDocument, baseOptions);
      }
export type UpdateContractMutationHookResult = ReturnType<typeof useUpdateContractMutation>;
export type UpdateContractMutationResult = Apollo.MutationResult<UpdateContractMutation>;
export type UpdateContractMutationOptions = Apollo.BaseMutationOptions<UpdateContractMutation, UpdateContractMutationVariables>;
export const UpdateDocumentsDocument = gql`
    mutation updateDocuments($id: Int!, $code: String!, $files: [DocumentFileInput!]!) {
  updateDocuments(id: $id, code: $code, files: $files) {
    ... on DocumentFileModel {
      uuid
      name
      type
      path
    }
  }
}
    `;
export type UpdateDocumentsMutationFn = Apollo.MutationFunction<UpdateDocumentsMutation, UpdateDocumentsMutationVariables>;

/**
 * __useUpdateDocumentsMutation__
 *
 * To run a mutation, you first call `useUpdateDocumentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDocumentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDocumentsMutation, { data, loading, error }] = useUpdateDocumentsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      code: // value for 'code'
 *      files: // value for 'files'
 *   },
 * });
 */
export function useUpdateDocumentsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDocumentsMutation, UpdateDocumentsMutationVariables>) {
        return Apollo.useMutation<UpdateDocumentsMutation, UpdateDocumentsMutationVariables>(UpdateDocumentsDocument, baseOptions);
      }
export type UpdateDocumentsMutationHookResult = ReturnType<typeof useUpdateDocumentsMutation>;
export type UpdateDocumentsMutationResult = Apollo.MutationResult<UpdateDocumentsMutation>;
export type UpdateDocumentsMutationOptions = Apollo.BaseMutationOptions<UpdateDocumentsMutation, UpdateDocumentsMutationVariables>;
export const GetCompanyByIcDocument = gql`
    query getCompanyByIc($ic: String!) {
  getCompanyByIc(ic: $ic) {
    name
    ico
    dic
  }
}
    `;

/**
 * __useGetCompanyByIcQuery__
 *
 * To run a query within a React component, call `useGetCompanyByIcQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanyByIcQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompanyByIcQuery({
 *   variables: {
 *      ic: // value for 'ic'
 *   },
 * });
 */
export function useGetCompanyByIcQuery(baseOptions: Apollo.QueryHookOptions<GetCompanyByIcQuery, GetCompanyByIcQueryVariables>) {
        return Apollo.useQuery<GetCompanyByIcQuery, GetCompanyByIcQueryVariables>(GetCompanyByIcDocument, baseOptions);
      }
export function useGetCompanyByIcLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCompanyByIcQuery, GetCompanyByIcQueryVariables>) {
          return Apollo.useLazyQuery<GetCompanyByIcQuery, GetCompanyByIcQueryVariables>(GetCompanyByIcDocument, baseOptions);
        }
export type GetCompanyByIcQueryHookResult = ReturnType<typeof useGetCompanyByIcQuery>;
export type GetCompanyByIcLazyQueryHookResult = ReturnType<typeof useGetCompanyByIcLazyQuery>;
export type GetCompanyByIcQueryResult = Apollo.QueryResult<GetCompanyByIcQuery, GetCompanyByIcQueryVariables>;
export const VerifyContractBySmsDocument = gql`
    mutation verifyContractBySMS($code: String!, $id: Int!, $verificationCode: String!) {
  verifyContractBySMS(code: $code, id: $id, verificationCode: $verificationCode)
}
    `;
export type VerifyContractBySmsMutationFn = Apollo.MutationFunction<VerifyContractBySmsMutation, VerifyContractBySmsMutationVariables>;

/**
 * __useVerifyContractBySmsMutation__
 *
 * To run a mutation, you first call `useVerifyContractBySmsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyContractBySmsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyContractBySmsMutation, { data, loading, error }] = useVerifyContractBySmsMutation({
 *   variables: {
 *      code: // value for 'code'
 *      id: // value for 'id'
 *      verificationCode: // value for 'verificationCode'
 *   },
 * });
 */
export function useVerifyContractBySmsMutation(baseOptions?: Apollo.MutationHookOptions<VerifyContractBySmsMutation, VerifyContractBySmsMutationVariables>) {
        return Apollo.useMutation<VerifyContractBySmsMutation, VerifyContractBySmsMutationVariables>(VerifyContractBySmsDocument, baseOptions);
      }
export type VerifyContractBySmsMutationHookResult = ReturnType<typeof useVerifyContractBySmsMutation>;
export type VerifyContractBySmsMutationResult = Apollo.MutationResult<VerifyContractBySmsMutation>;
export type VerifyContractBySmsMutationOptions = Apollo.BaseMutationOptions<VerifyContractBySmsMutation, VerifyContractBySmsMutationVariables>;
export const LoginDocument = gql`
    mutation login($password: String!) {
  login(password: $password) {
    token
  }
}
    `;
export type LoginMutationFn = Apollo.MutationFunction<LoginMutation, LoginMutationVariables>;

/**
 * __useLoginMutation__
 *
 * To run a mutation, you first call `useLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginMutation, { data, loading, error }] = useLoginMutation({
 *   variables: {
 *      password: // value for 'password'
 *   },
 * });
 */
export function useLoginMutation(baseOptions?: Apollo.MutationHookOptions<LoginMutation, LoginMutationVariables>) {
        return Apollo.useMutation<LoginMutation, LoginMutationVariables>(LoginDocument, baseOptions);
      }
export type LoginMutationHookResult = ReturnType<typeof useLoginMutation>;
export type LoginMutationResult = Apollo.MutationResult<LoginMutation>;
export type LoginMutationOptions = Apollo.BaseMutationOptions<LoginMutation, LoginMutationVariables>;
export const PartnerLoginDocument = gql`
    mutation partnerLogin($phone: String!) {
  partnerLogin(phone: $phone)
}
    `;
export type PartnerLoginMutationFn = Apollo.MutationFunction<PartnerLoginMutation, PartnerLoginMutationVariables>;

/**
 * __usePartnerLoginMutation__
 *
 * To run a mutation, you first call `usePartnerLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerLoginMutation, { data, loading, error }] = usePartnerLoginMutation({
 *   variables: {
 *      phone: // value for 'phone'
 *   },
 * });
 */
export function usePartnerLoginMutation(baseOptions?: Apollo.MutationHookOptions<PartnerLoginMutation, PartnerLoginMutationVariables>) {
        return Apollo.useMutation<PartnerLoginMutation, PartnerLoginMutationVariables>(PartnerLoginDocument, baseOptions);
      }
export type PartnerLoginMutationHookResult = ReturnType<typeof usePartnerLoginMutation>;
export type PartnerLoginMutationResult = Apollo.MutationResult<PartnerLoginMutation>;
export type PartnerLoginMutationOptions = Apollo.BaseMutationOptions<PartnerLoginMutation, PartnerLoginMutationVariables>;
export const PartnerLoginVerificationDocument = gql`
    mutation partnerLoginVerification($code: String!) {
  partnerLoginVerification(code: $code) {
    token
  }
}
    `;
export type PartnerLoginVerificationMutationFn = Apollo.MutationFunction<PartnerLoginVerificationMutation, PartnerLoginVerificationMutationVariables>;

/**
 * __usePartnerLoginVerificationMutation__
 *
 * To run a mutation, you first call `usePartnerLoginVerificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerLoginVerificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerLoginVerificationMutation, { data, loading, error }] = usePartnerLoginVerificationMutation({
 *   variables: {
 *      code: // value for 'code'
 *   },
 * });
 */
export function usePartnerLoginVerificationMutation(baseOptions?: Apollo.MutationHookOptions<PartnerLoginVerificationMutation, PartnerLoginVerificationMutationVariables>) {
        return Apollo.useMutation<PartnerLoginVerificationMutation, PartnerLoginVerificationMutationVariables>(PartnerLoginVerificationDocument, baseOptions);
      }
export type PartnerLoginVerificationMutationHookResult = ReturnType<typeof usePartnerLoginVerificationMutation>;
export type PartnerLoginVerificationMutationResult = Apollo.MutationResult<PartnerLoginVerificationMutation>;
export type PartnerLoginVerificationMutationOptions = Apollo.BaseMutationOptions<PartnerLoginVerificationMutation, PartnerLoginVerificationMutationVariables>;
export const VerifyDocument = gql`
    query verify($token: String!) {
  verify(token: $token) {
    scope
    iat
    exp
  }
}
    `;

/**
 * __useVerifyQuery__
 *
 * To run a query within a React component, call `useVerifyQuery` and pass it any options that fit your needs.
 * When your component renders, `useVerifyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVerifyQuery({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useVerifyQuery(baseOptions: Apollo.QueryHookOptions<VerifyQuery, VerifyQueryVariables>) {
        return Apollo.useQuery<VerifyQuery, VerifyQueryVariables>(VerifyDocument, baseOptions);
      }
export function useVerifyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VerifyQuery, VerifyQueryVariables>) {
          return Apollo.useLazyQuery<VerifyQuery, VerifyQueryVariables>(VerifyDocument, baseOptions);
        }
export type VerifyQueryHookResult = ReturnType<typeof useVerifyQuery>;
export type VerifyLazyQueryHookResult = ReturnType<typeof useVerifyLazyQuery>;
export type VerifyQueryResult = Apollo.QueryResult<VerifyQuery, VerifyQueryVariables>;